import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../services/api';

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const token = searchParams.get('token');
  const initialStatus = searchParams.get('status');

  useEffect(() => {
    if (initialStatus === 'success') {
      setStatus('success');
    } else if (initialStatus === 'error') {
      setStatus('error');
    } else if (token) {
      const doUnsubscribe = async () => {
        try {
          await api.post(`/email-preferences/unsubscribe/${token}`);
          setStatus('success');
        } catch {
          setStatus('error');
        }
      };
      doUnsubscribe();
    } else {
      setStatus('error');
    }
  }, [token, initialStatus]);

  const handleResubscribe = async () => {
    try {
      await api.post(`/email-preferences/resubscribe/${token}`);
      setStatus('resubscribed');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h2 className="text-3xl font-extrabold text-gray-900">Email Preferences</h2>
        </div>

        {status === 'loading' && (
          <div className="bg-blue-50 p-6 rounded-lg">
            <p className="text-blue-800">Processing your request...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="bg-green-50 p-6 rounded-lg">
            <h3 className="text-lg font-medium text-green-900 mb-2">Unsubscribed</h3>
            <p className="text-sm text-green-800">
              You've been unsubscribed from marketing emails. You'll still receive important account notifications.
            </p>
            {token && (
              <button
                onClick={handleResubscribe}
                className="mt-4 text-sm text-indigo-600 hover:text-indigo-800 underline"
              >
                Changed your mind? Resubscribe
              </button>
            )}
          </div>
        )}

        {status === 'resubscribed' && (
          <div className="bg-green-50 p-6 rounded-lg">
            <h3 className="text-lg font-medium text-green-900 mb-2">Resubscribed</h3>
            <p className="text-sm text-green-800">
              You've been resubscribed to marketing emails.
            </p>
          </div>
        )}

        {status === 'error' && (
          <div className="bg-red-50 p-6 rounded-lg">
            <h3 className="text-lg font-medium text-red-900 mb-2">Invalid Link</h3>
            <p className="text-sm text-red-800">
              This unsubscribe link is invalid or has expired.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;
